// extracted by mini-css-extract-plugin
module.exports = {"button":"style-module--button--2dnz7","disabled":"style-module--disabled--1LeLQ","secondary":"style-module--secondary--2g5PD"};